import React from "react";
import PropTypes from "prop-types";

import './TitleElement.m.css';

const TitleElement = ({ element, usePartnershipStyle = false }) => {
  // Title elements can have content in either 'title' or 'text' field
  const content = element.title || element.text;

  if (!content) return null;

  return (
    <div styleName={`story-element text-element ${usePartnershipStyle ? "partnership-style" : ""}`}>
      <h2>{content}</h2>
    </div>
  );
};

TitleElement.propTypes = {
  element: PropTypes.object.isRequired,
  usePartnershipStyle: PropTypes.bool,
};

export default TitleElement;
